var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarsTrustpilot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 9,
    viewBox: "0 0 48 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30984 0.289062H0.5V9.00019H9.30984V0.289062Z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 0.289062H10.0586V9.00019H18.8684V0.289062Z",
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3841 0.289062H19.5742V9.00019H28.3841V0.289062Z",
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9427 0.289062H29.1328V9.00019H37.9427V0.289062Z",
    fill: "#00B67A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5026 0.288086H43.0977V8.99922H47.5026V0.288086Z",
    fill: "#DCDCE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0963 0.288086H38.6914V8.99922H43.0963V0.288086Z",
    fill: "#00B67A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90716 6.15441L6.24338 5.81975L6.80167 7.52021L4.90716 6.15441ZM7.9823 3.95647H5.63019L4.90716 1.76758L4.18414 3.95647H1.83203L3.73569 5.31323L3.01266 7.50212L4.91632 6.14537L6.0878 5.31323L7.9823 3.95647Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4619 6.15441L15.7981 5.81975L16.3564 7.52021L14.4619 6.15441ZM17.537 3.95647H15.1849L14.4619 1.76758L13.7388 3.95647H11.3867L13.2904 5.31323L12.5673 7.50212L14.471 6.14537L15.6425 5.31323L17.537 3.95647Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9775 6.15441L25.3137 5.81975L25.872 7.52021L23.9775 6.15441ZM27.0526 3.95647H24.7005L23.9775 1.76758L23.2545 3.95647H20.9023L22.806 5.31323L22.083 7.50212L23.9866 6.14537L25.1581 5.31323L27.0526 3.95647Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5361 6.15441L34.8723 5.81975L35.4306 7.52021L33.5361 6.15441ZM36.6112 3.95647H34.2591L33.5361 1.76758L32.813 3.95647H30.4609L32.3646 5.31323L31.6416 7.50212L33.5452 6.14537L34.7167 5.31323L36.6112 3.95647Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0947 6.15441L44.4309 5.81975L44.9892 7.52021L43.0947 6.15441ZM46.1698 3.95647H43.8177L43.0947 1.76758L42.3716 3.95647H40.0195L41.9232 5.31323L41.2002 7.50212L43.1038 6.14537L44.2753 5.31323L46.1698 3.95647Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsTrustpilot);
export default __webpack_public_path__ + "static/media/stars-trustpilot.1f17d124d662c312962bc434005ea251.svg";
export { ForwardRef as ReactComponent };